import { call, put, select } from 'redux-saga/effects';

import { authTokenSelector } from 'store/auth/selectors';
import { openSupportForm, openSupportFormSuccess } from 'store/user/actions';

import { decagonClient } from 'services/decagonClient';
import sentry from 'services/Sentry/SentryInstance';

import { generateContactUsLink } from 'helpers/helpCenter';
import { redirectTo } from 'helpers/utils';

import { waitForGetAuthTokenRequest } from './helpers';

function* redirectToContactUsFallback() {
    yield call(redirectTo, generateContactUsLink());
}

export function* openSupportFormSaga({ payload }: ReturnType<typeof openSupportForm>) {
    const { chatIsVisible = false } = payload ?? {};

    try {
        yield call(waitForGetAuthTokenRequest);
    } catch (error) {
        sentry.sentrySagaLog(error as Error, 'openSupportFormSaga');

        yield* redirectToContactUsFallback();

        return;
    }

    const authToken: string | null = yield select(authTokenSelector);

    if (chatIsVisible && authToken) {
        try {
            yield call(decagonClient.initialise, { authToken });

            yield call(decagonClient.open);

            yield put(openSupportFormSuccess());
        } catch (e) {
            yield* redirectToContactUsFallback();
        }
    } else {
        yield* redirectToContactUsFallback();
    }
}

export function* closeChatbotSaga() {
    try {
        yield call(decagonClient.hide);
    } catch (error) {
        sentry.sentrySagaLog(error as Error, 'closeChatbotSaga');
    }
}
